import { render, staticRenderFns } from "./UniversityFaculty.vue?vue&type=template&id=15530092&"
import script from "./UniversityFaculty.vue?vue&type=script&lang=js&"
export * from "./UniversityFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports